import { markRaw } from 'vue'
import {
  Home,
  BandwidthV2,
  MailAndCalendarProduct,
  ContactCenter,
  AIStudio,
  Device,
  Link,
  Keypad10Dots,
  Phone,
  Rooms,
  Scheduler,
  TeamChat,
  AllUser,
  Huddles,
  WorkspaceReservation,
  EllipsisVertical,
  ProxyV2,
  Wrench,
  Setting,
  Profile,
  Participants,
  Agenda,
  Billing,
  MeshFill,
  CustomizeV2,
  AccountInformation,
  BellNotificationOn,
  Star,
  ReleaseEngagement,
  SurveyResults,
  DigitalSignage,
  Minimap,
  External,
  AgentEngagement,
  SchedulingDisplay,
  SSO,
  Team,
  Contact,
  AIDocs,
  AudioConferencing,
  VideoOn,
  Email,
  Whiteboard,
  Clips,
  Tasks,
  Hub,
  WEMQualityManagement,
  ShieldCheckmark,
  ProfilePrivacy,
  AICompanion,
  Events,
  RevenueAccelerator,
  FlowFill,
  Notes,
  Webinars,
  SurveyV2,
  RecordFill,
  Marketplace,
  AgentAssist,
  FileFormatDocument,
  FileFormatSpreadsheet,
  FileFormatPresentation,
  ClinicalNote,
  H323OrSIP,
  ClientBrowser,
  Analytics,
  ComplianceManager,
  ConferenceRoomConnector,
  Integration,
  SMS,
  FileResource,
  Tickets,
  APIs,
  VirtualAgent,
  IntentManager,
  KnowledgeBase,
  VideoIncoming,
  VideoContent,
  Attachment,
  ZoomRoomPersonal,
  TemplateMiscellaneous,
  PhonePowerPack,
  Poll,
  Gift,
  Summarize,
  Refresh,
  PlatformSolutions,
  ShieldLock,
  VideoManagement,
  Adjust,
  CreditCard,
  Refund,
  Workvivo,
  MyNotes
} from '@zoom/icons-vue'

import {
  AccountManagement,
  // AutomatedOrder,
  ContentManagement,
  DevicePolicy,
  Frontline,
  // OnlineOrder,
  // PhoneDialInContacts,
  PhoneIntegration,
  // ResourceManagement,
  Skype,
  SubAccountManagement,
  AgentAI,
  AccountDelegated
} from './icon-components'

const settingsIconMaps = {
  aicompanion: markRaw(AICompanion),
  general: markRaw(Setting),
  frontline: markRaw(Frontline),
  meeting: markRaw(VideoOn),
  webinar: markRaw(Webinars),
  zoomevents: markRaw(Events),
  clinicalNote: markRaw(ClinicalNote),
  recording: markRaw(RecordFill),
  videos: markRaw(VideoManagement),
  zoomMailCalendar: markRaw(Email),
  telephony: markRaw(AudioConferencing),
  pbx: markRaw(Phone),
  chat: markRaw(TeamChat),
  workvivo: markRaw(Workvivo),
  zoomapps: markRaw(Marketplace),
  onzoom: markRaw(Marketplace),
  whiteboard: markRaw(Whiteboard),
  notes: markRaw(Notes),
  zmDoc: markRaw(AIDocs),
  zmPaper: markRaw(FileFormatDocument),
  zmSheets: markRaw(FileFormatSpreadsheet),
  zmSheet: markRaw(FileFormatSpreadsheet),
  zmPresent: markRaw(FileFormatPresentation),
  zmSlides: markRaw(FileFormatPresentation),
  zmSlide: markRaw(FileFormatPresentation),
  zoomTasks: markRaw(Tasks),
  zmHub: markRaw(Hub),
  iq: markRaw(RevenueAccelerator),
  qm: markRaw(WEMQualityManagement),
  tsp: markRaw(AudioConferencing),
  zoomclips: markRaw(Clips),
  zoomassistant: markRaw(AgentAssist),
  surveyPoll: markRaw(SurveyV2),
  workflows: markRaw(FlowFill),
  cobrowse: markRaw(Setting),
  crcVideosdkConferencing: markRaw(H323OrSIP),
  workspace: markRaw(WorkspaceReservation),
  kiwi: markRaw(RevenueAccelerator)
}
export const iconMaps = {
  'personal-menu-item-profile': markRaw(Profile),
  'profile-menu-item-reports-new-with-external-biz': markRaw(Agenda),
  'personal-menu-item-personal-devices': markRaw(Device),
  'personal-menu-item-myphone': markRaw(Phone),
  'personal-menu-item-pbx-upgrade': markRaw(Phone),
  'personal-menu-item-personal-cci': markRaw(ContactCenter),
  'personal-menu-item-recording': markRaw(RecordFill),
  'profile-menu-item-admin-center': markRaw(AccountInformation),
  'personal-menu-item-summaries': markRaw(Summarize),
  'personal-menu-item-my_notes': markRaw(MyNotes),
  'admin-menu-item-companysetup': markRaw(Wrench),
  'personal-menu-item-personal-contacts': markRaw(Contact),
  'admin-menu-item-dashboard': markRaw(BandwidthV2),
  'sidemenu-mail-calendar-management': markRaw(MailAndCalendarProduct),
  'sidemenu-user-management': markRaw(AllUser),
  'sidemenu-channel': markRaw(TeamChat),
  'device-management-menus': markRaw(Device),
  'node-management-menus': markRaw(Link),
  'room-management': markRaw(Rooms),
  'workspaces-management': markRaw(WorkspaceReservation),
  'profile-menu-item-reports-new-without-external-biz': markRaw(Agenda),
  'profile-menu-item-reports-old-without-data-request': markRaw(Agenda),
  'analytics-reports-personal-usage-report': markRaw(ClientBrowser),
  'analytics-reports-personal-activity-report': markRaw(Analytics),
  pbx_billing_container: markRaw(Phone),
  pbx_column_container: markRaw(Phone),
  contact_center_column_container: markRaw(ContactCenter),
  phone_number_management_column_container: markRaw(Keypad10Dots),
  new_ai_studio_column_container: markRaw(AIStudio),
  'side-menu-advance': markRaw(EllipsisVertical),
  'admin-menu-item-spot': markRaw(Huddles),
  'single-billing-menu': markRaw(Billing),
  'admin-menu-item-node-introduction': markRaw(ProxyV2),
  'menu-subacc': markRaw(SubAccountManagement),
  'menu-subacc-sub': markRaw(SubAccountManagement),
  'menu-account-management': markRaw(AccountManagement),
  'content-management': markRaw(ContentManagement),
  'admin-menu-item-home': markRaw(Home),
  'admin-menu-item-admin-destination-home': markRaw(Home),
  'account-menu-item-reports': markRaw(Agenda),
  'account-menu-item-billing': markRaw(Billing),
  'menu-billing': markRaw(Adjust),
  'menu-billing-payment': markRaw(Billing),
  'menu-billing-history': markRaw(CreditCard),
  'menu-billing-refer': markRaw(Refund),
  'menu-billing-credits': markRaw(AICompanion),
  'advance-menu-item-mesh': markRaw(MeshFill),
  'configure-products': markRaw(CustomizeV2),
  'account-menu-item-profile': markRaw(AccountInformation),
  'account-menu-item-notification': markRaw(BellNotificationOn),
  'advance-menu-item-branding': markRaw(Star),
  'advance-menu-item-sms-campaigns': markRaw(SMS),
  'admin-menu-item-ai-management': markRaw(AICompanion),
  'account-menu-item-release-control': markRaw(ReleaseEngagement),
  'account-menu-feature-request': markRaw(SurveyResults),
  'account-menu-item-information-barriers': markRaw(DigitalSignage),
  'account-menu-item-location-management': markRaw(Minimap),
  'account-menu-item-external-accounts': markRaw(AccountDelegated),
  'account-menu-item-subscription-center': markRaw(AgentEngagement),
  'account-menu-item-track': markRaw(SchedulingDisplay),
  'account-menu-item-sso': markRaw(SSO),
  'advance-menu-item-sso': markRaw(SSO),
  'user-menu-item-users': markRaw(Profile),
  'user-menu-item-group': markRaw(AllUser),
  'user-menu-item-roles': markRaw(Participants),
  'user-menu-item-divisions': markRaw(Team),
  'user-menu-item-contacts': markRaw(Contact),
  'user-menu-item-external-contacts': markRaw(External),
  'advance-menu-item-security': markRaw(ShieldCheckmark),
  'profile-settings-privacy-setting': markRaw(ProfilePrivacy),
  // 'advance-menu-item-privacy-setting': markRaw(ProfilePrivacy),
  'personal-menu-item-data-privacy': markRaw(ProfilePrivacy),
  'advance-menu-item-tsp': markRaw(AudioConferencing),
  'advance-menu-item-docs-migration': markRaw(AIDocs),
  'account-menu-item-sipphone': markRaw(PhoneIntegration),
  'account-menu-item-clips': markRaw(Clips),
  'account-menu-item-videos': markRaw(VideoManagement),
  'account-menu-item-docs': markRaw(AIDocs),
  'account-menu-item-notes': markRaw(Notes),
  'account-menu-item-recording': markRaw(RecordFill),
  'admin-menu-item-scheduler': markRaw(Scheduler),
  'account-menu-item-survey': markRaw(SurveyV2),
  'account-menu-item-tasks': markRaw(Tasks),
  'account-menu-item-wallboard': markRaw(Agenda),
  'account-menu-item-whiteboard': markRaw(Whiteboard),
  'account-menu-item-workflow': markRaw(FlowFill),
  'menu-usage-report': markRaw(ClientBrowser),
  'menu-activity-report': markRaw(Analytics),
  // 'menu-data-subject-requests': markRaw(ComplianceManager),
  // 'menu-data-request-history': markRaw(AgentEngagement),
  'advance-menu-item-developer': markRaw(Marketplace),
  'advance-menu-item-hybrid': markRaw(ConferenceRoomConnector),
  'advance-menu-item-integration': markRaw(Integration),
  'subacc-menu-item': markRaw(AllUser),
  'subacc-menu-item-sub': markRaw(AllUser),
  'subacc-menu-item-sub_dashboard': markRaw(BandwidthV2),
  'subacc-menu-item-sub_dashboard_admin': markRaw(BandwidthV2),
  'subacc-menu-item-sub_list': markRaw(AllUser),
  'sub_account-menu-item-resource-management': markRaw(FileResource),
  'subacc-menu-item-invoice_history': markRaw(Tickets),
  'subacc-menu-item-sub_order_log': markRaw(ComplianceManager),
  'subacc-menu-item-sub_order_log-sub': markRaw(ComplianceManager),
  'subacc-menu-item-report': markRaw(Analytics),
  'subacc-menu-item-sub_report': markRaw(Analytics),
  'account-menu-item-dashboard': markRaw(BandwidthV2),
  'account-menu-item-setting': markRaw(Setting),
  'personal-menu-item-analytics_reports': markRaw(Agenda),
  'account-menu-item-roles': markRaw(Participants),
  'zoom-support-menus': markRaw(APIs),
  'account-menu-item-hub': markRaw(Hub),
  'account-menu-item-paper': markRaw(FileFormatDocument),
  'account-menu-item-sheet': markRaw(FileFormatSpreadsheet),
  'account-menu-item-present': markRaw(FileFormatPresentation),
  'analytics-reports-meeting': markRaw(VideoOn),
  'analytics-reports-zoom-phone': markRaw(Phone),
  'analytics-reports-contact-center': markRaw(Analytics),
  'analytics-reports-contact-center-legacy': markRaw(ContactCenter),
  'analytics-reports-virtual-agent': markRaw(VirtualAgent),
  'analytics-reports-zva-custom-agents': markRaw(AgentAssist),
  'analytics-reports-zva-intents': markRaw(IntentManager),
  'analytics-reports-zva-knowledge-base': markRaw(KnowledgeBase),
  'personal-menu-item-data-request': markRaw(ComplianceManager),
  'personal-menu-item-data-history': markRaw(AgentEngagement),
  'meeting-menu-item-upcoming': markRaw(VideoIncoming),
  'meeting-menu-item-previous': markRaw(VideoContent),
  'meeting-menu-item-assets': markRaw(Attachment),
  'meeting-menu-item-pmi': markRaw(ZoomRoomPersonal),
  'meeting-menu-item-templates': markRaw(TemplateMiscellaneous),
  'meeting-menu-item-tsp': markRaw(PhonePowerPack),
  'meeting-menu-item-poll-template': markRaw(Poll),
  'meeting-menu-item-agendas': markRaw(Agenda),
  'meeting-menu-item-whatis': markRaw(Gift),
  'meeting-menu-item-pac': markRaw(PhonePowerPack),
  'profile-menu-item-profile': markRaw(Profile),
  'personal-menu-item-setting': markRaw(Setting),
  'profile-menu-item-billing': markRaw(Billing),
  'profile-menu-item-reports-simple': markRaw(Agenda),
  'profile-menu-item-reports-with-children': markRaw(Agenda),
  'webinar-menu-item-upcoming': markRaw(VideoIncoming),
  'webinar-menu-item-previous': markRaw(VideoContent),
  'webinar-menu-item-templates': markRaw(TemplateMiscellaneous),
  'webinar-menu-item-poll-template': markRaw(Poll),
  'webinar-menu-item-whatis': markRaw(Gift),
  accountLeftNavMeetingSummaryManagement: markRaw(Summarize),
  'advance-menu-item-information-barriers': markRaw(DigitalSignage),
  'zoom-node-header': markRaw(Link),
  'account-menu-item-vrc': markRaw(ConferenceRoomConnector),
  'node-menu-item-dashboard': markRaw(BandwidthV2),
  'node-menu-item-modules': markRaw(ProxyV2),
  'node-menu-item-home': markRaw(ProxyV2),
  'node-menu-item-updates': markRaw(Refresh),
  'node-menu-item-settings': markRaw(Setting),
  'support-buildAPI': markRaw(Marketplace),
  'support-document': markRaw(AIDocs),
  'support-help-center': markRaw(PlatformSolutions),
  agent_management_menu: markRaw(AgentAI),
  'account-menu-item-compliance': markRaw(ComplianceManager),
  'account-menu-item-phone': markRaw(Phone),
  'menu-featuresetting-report': markRaw(Setting),
  'security-privacy': markRaw(ShieldLock),
  'security-data-privacy': markRaw(ShieldLock),
  kiwi_column_container: markRaw(RevenueAccelerator),
  kiwi_qm_column_container: markRaw(WEMQualityManagement),
  'frontline-management': markRaw(Frontline),
  'advance-menu-item-lync': markRaw(Skype),
  'advance-menu-item-device-policy': markRaw(DevicePolicy),
  'advance-menu-item-crossHybrid': markRaw(Scheduler),
  'account-menu-item-meeting-connector': markRaw(ConferenceRoomConnector),
  'admin-nav-list': markRaw(SubAccountManagement),
  'profile-menu-item-account-profile': markRaw(AccountInformation),
  'advance-menu-item-cpaas': markRaw(APIs),
  'account-menu-item-referral': markRaw(Gift),
  'contact_center_column_container-dynamic': markRaw(ContactCenter),
  'contact_center_column_container-static': markRaw(ContactCenter),
  pbx_column_container_dynamic: markRaw(Phone),
  pbx_column_container_static: markRaw(Phone),
  'admin-menu-item-workforce': markRaw(AllUser),
  'menu-billing-report': markRaw(Analytics),
  'menu-subacc-customer': markRaw(SubAccountManagement),
  'subacc-menu-item-partner_order_history': markRaw(Tickets),
  'subacc-menu-item-resource-management': markRaw(FileResource),
  'subacc-menu-item-sub_order_log-customer': markRaw(ComplianceManager),
  'subacc-menu-item-sub_invoice_history': markRaw(Tickets),
  'profile-menu-item-reports-old-with-data-request': markRaw(Agenda),
  'personal-menu-item-reports-main': markRaw(Agenda),
  'account-menu-item-im': markRaw(TeamChat),
  'admin-menu-link-marketplace-management': markRaw(Marketplace),
  'support-developerForum': markRaw(Marketplace),
  'admin-menu-item-marketplace-management': markRaw(Marketplace),
  'settings-policies': markRaw(Setting),
  'cx-management': markRaw(ContactCenter)
}

for (const key in settingsIconMaps) {
  iconMaps[`settings-${key}`] = settingsIconMaps[key]
  iconMaps[`profile-settings-${key}`] = settingsIconMaps[key]
}
